import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Firebase
import { storage, db } from "../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { collection, doc, setDoc } from "firebase/firestore";

function CrearGregario() {
  const navigate = useNavigate();

  // Estados
  const [nombreInput, setNombre] = useState("");
  const [pictureURL, setPictureUrl] = useState("");
  const [isLoadingPicture, setIsLoadingPicture] = useState(false);

  // Handlers
  const handleNombreChange = (e) => setNombre(e.target.value);

  // 📸 Subir foto
  const handlePictureChange = async (e) => {
    setIsLoadingPicture(true);
    const image = e.target.files[0];

    try {
      const storageRef = ref(storage, `gregarios/images/${image.name}`);
      const snapShot = await uploadBytes(storageRef, image);
      const downloadUrl = await getDownloadURL(snapShot.ref);
      setPictureUrl(downloadUrl);
      console.log("foto gregario", downloadUrl);
      setIsLoadingPicture(false);
    } catch (error) {
      navigate("/error");
    }
  };

  // 🚀 Crear Gregario en Firestore
  const handleCreateGregario = async (e) => {
    e.preventDefault();

    try {
      const gregariosRef = collection(db, "gregarios");
      const newGregarioDocRef = doc(gregariosRef);

      await setDoc(newGregarioDocRef, {
        id: newGregarioDocRef.id,
        nombre: nombreInput,
        foto: pictureURL,
      });

      alert("Gregario creado correctamente");
      navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="page">
      <section className="general-container">
        <div className="form-container">
          <form>
            <h3>Crear Gregario</h3>

            {/* Nombre */}
            <div className="input-container">
              <input value={nombreInput} onChange={handleNombreChange} />
              <label className={nombreInput && "filled"}>Nombre</label>
            </div>

            {/* Foto */}
            <div className="uploader-pic">
          <h3>Selecciona una imagen</h3>

              <input onChange={handlePictureChange} type="file" />
              <label>Foto Gregario</label>
            </div>

            {isLoadingPicture && <p>Subiendo foto...</p>}

            {pictureURL && (
              <img src={pictureURL} alt="gregario" width={200} className="uploader-img" />
            )}

            <button type="submit" onClick={handleCreateGregario} className="general-btn">
              Crear Gregario
            </button>
          </form>
        </div>
      </section>
    </div>

  );
}

export default CrearGregario;